import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="footer">
      <hr className="rule" />
      <div className="container row-s" style={{ minHeight: 64, color: "var(--text-muted)", fontSize: 12, flexWrap: "wrap", gap: "var(--s-3)" }}>
        <div className="t-mono">LEX · 30 · A thirty-day vocabulary almanac</div>
        <div className="t-mono" style={{ display: "flex", gap: "var(--s-4)" }}>
          <Link to="/privacy" style={{ color: "inherit" }}>Privacy</Link>
          <Link to="/terms" style={{ color: "inherit" }}>Terms</Link>
          <span>{new Date().getFullYear()} · ETS 30-day TOEIC corpus</span>
        </div>
      </div>
    </footer>
  );
}
